module.exports = __webpack_public_path__ + "static/media/yellow-september.f183cefe.jpg";